/* Leaves Lighting — PDP variant selection, gallery, spec tabs, add-to-cart. */
(function () {
  var P = window.__PDP || { variants: [], optionCount: 0, selected: [] };
  function money(c) { return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  var sel = (P.selected || []).slice();
  var qty = 1;

  function sameOptions(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
    return true;
  }
  function currentVariant() {
    for (var i = 0; i < P.variants.length; i++) if (sameOptions(P.variants[i].options, sel)) return P.variants[i];
    return null;
  }

  function stockLabel(el, key, fallback) {
    return (el && el.getAttribute('data-label-' + key)) || fallback;
  }

  function paint() {
    // option button active states
    $all('[data-opt-index]').forEach(function (btn) {
      var i = parseInt(btn.getAttribute('data-opt-index'), 10);
      btn.classList.toggle('is-active', btn.getAttribute('data-value') === sel[i]);
    });
    // swatch value labels
    $all('[data-opt-value]').forEach(function (lbl) {
      var i = parseInt(lbl.getAttribute('data-opt-value'), 10);
      lbl.textContent = sel[i] || '';
    });
    var v = currentVariant();
    var priceEl = $('[data-pdp-price]'), skuEl = $('[data-pdp-sku]'), addPrice = $('[data-add-price]');
    var stockEl = $('[data-pdp-stock]'), dotEl = $('[data-pdp-stockdot]'), hiddenId = $('[data-pdp-variant]');
    var addBtn = $('[data-pdp-add]'), hero = $('[data-pdp-hero]');
    if (v) {
      if (priceEl) priceEl.textContent = money(v.price);
      if (skuEl) skuEl.textContent = v.sku || '';
      if (addPrice) addPrice.textContent = money(v.price * qty);
      if (hiddenId) hiddenId.value = v.id;
      if (v.image && hero) { hero.src = v.image; markThumb(v.image); }
      if (stockEl) stockEl.textContent = v.available ? stockLabel(stockEl, 'in', 'In stock') : stockLabel(stockEl, 'made', 'Made to order');
      if (dotEl) dotEl.style.background = v.available ? 'var(--color-sage)' : 'var(--color-neutral-light)';
      if (addBtn) addBtn.disabled = false;
    } else {
      if (stockEl) stockEl.textContent = stockLabel(stockEl, 'un', 'Unavailable');
      if (addBtn) addBtn.disabled = true;
    }
  }

  function markThumb(src) {
    $all('[data-pdp-thumb]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-pdp-thumb') === src); });
  }

  document.addEventListener('click', function (e) {
    var opt = e.target.closest && e.target.closest('[data-opt-index]');
    if (opt) { sel[parseInt(opt.getAttribute('data-opt-index'), 10)] = opt.getAttribute('data-value'); paint(); return; }

    var thumb = e.target.closest && e.target.closest('[data-pdp-thumb]');
    if (thumb) { var hero = $('[data-pdp-hero]'); if (hero) hero.src = thumb.getAttribute('data-pdp-thumb'); markThumb(thumb.getAttribute('data-pdp-thumb')); return; }

    if (e.target.closest && e.target.closest('[data-qty-dec]')) { qty = Math.max(1, qty - 1); var q1 = $('[data-qty]'); if (q1) q1.textContent = qty; paint(); return; }
    if (e.target.closest && e.target.closest('[data-qty-inc]')) { qty = qty + 1; var q2 = $('[data-qty]'); if (q2) q2.textContent = qty; paint(); return; }

    if (e.target.closest && e.target.closest('[data-pdp-add]')) {
      var v = currentVariant(); if (!v) return;
      if (window.lvCartAdd) window.lvCartAdd(v.id, qty);
      return;
    }

    var tab = e.target.closest && e.target.closest('[data-spec-tab]');
    if (tab) {
      var key = tab.getAttribute('data-spec-tab');
      $all('[data-spec-tab]').forEach(function (b) { b.classList.toggle('is-active', b === tab); });
      $all('[data-spec-panel]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-spec-panel') === key); });
      return;
    }
  });

  paint();
})();
